// Blob download helpers.
//
// Older exports in this codebase hardcode a Hebrew filename at each call site and
// build the Blob with `this.excelMimeType` — which is undefined in almost every
// component that references it, so those blobs end up with an empty MIME type and
// work only because of the .xlsx extension. The newer endpoints set
// Content-Disposition, so prefer the server's filename and fall back to a caller-
// supplied default.

// The real OpenXML type. (`application/vnd.ms-excel` is the legacy .xls type and
// is what the older call sites intended to use.)
const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// Pull the filename out of a Content-Disposition header. Handles both `filename=`
// and RFC 5987 `filename*=UTF-8''...`, quoted or bare.
const parseFilename = (headers, fallback) => {
    const cd = headers && (headers['content-disposition'] || headers['Content-Disposition']);
    if (cd) {
        const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
        if (match && match[1]) {
            try {
                return decodeURIComponent(match[1]);
            } catch (e) {
                // A filename with a stray % isn't valid percent-encoding; take it as-is.
                return match[1];
            }
        }
    }
    return fallback;
};

const saveBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

// Save an .xlsx response: `data` is the blob, `headers` the axios response headers.
const saveXlsx = (data, headers, fallbackName) =>
    saveBlob(new Blob([data], { type: XLSX_MIME }), parseFilename(headers, fallbackName));

export default {
    XLSX_MIME,
    parseFilename,
    saveBlob,
    saveXlsx,
};
